import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { okaidia } from 'react-syntax-highlighter/dist/esm/styles/prism';

const CodeSnippet = ({ code }) => (
  <SyntaxHighlighter language="javascript" style={okaidia} className="rounded-lg shadow-lg my-4 p-4 bg-gray-800 text-white">
    {code}
  </SyntaxHighlighter>
);

export default CodeSnippet;
